import { mergeProps, splitProps } from 'solid-js';
import { JSX } from 'solid-js/jsx-runtime';

export const GlobeIcon = (props: JSX.SvgSVGAttributes<SVGSVGElement>) => {
  const merged = mergeProps(
    {
      width: 16,
      height: 16,
    },
    props,
  );

  const [local, rest] = splitProps(merged, ['width', 'height']);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      {...local}
      {...rest}
    >
      <rect width="256" height="256" fill="none" />
      <circle
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <path
        d="M168,128c0,64-40,96-40,96s-40-32-40-96,40-96,40-96S168,64,168,128Z"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <line
        x1="37.46"
        y1="96"
        x2="218.54"
        y2="96"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <line
        x1="37.46"
        y1="160"
        x2="218.54"
        y2="160"
        fill="none"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </svg>
  );
};
